import SkeletonLoader from './skeletonLoader';
import ButtonLoader from './buttonLoader';
import InlineLoader from './inlineLoader';
import TableLoader from './tableLoader';
import CardLoader from './cardLoader';

export {
  SkeletonLoader,
  ButtonLoader,
  InlineLoader,
  TableLoader,
  CardLoader,
};
